<template>
  <div class="tenantList">
    <div class="intro-y box overflow-hidden mt-5 row">
      <pie title='租客管理' @legendselectchanged="legendselectchanged"/>
      <earlyList/>
    </div>
    <div class="search-form intro-y box p-5 mt-5" style='padding-bottom: 0;'>
      <el-form :form="form" inline>
        <el-form-item label="承租人或使用人：">
          <el-input v-model='form.lesseeName' placeholder="请输入承租人或使用人名称进行查询" style="width:240px;"/>
        </el-form-item>
        <el-form-item label="管理单位名称：">
          <el-select style="width: 200px" v-model='form.companyId' placeholder="请选择">
            <el-option
              v-for="item in unitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在行业：">
          <el-select style="width: 200px" v-model='form.tradeId' placeholder="请选择所在行业">
            <el-option
              v-for="(item,index) in detail"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出现预警：">
          <el-select style="width: 200px" v-model='form.warningFlag' placeholder="请选择出现预警">
            <el-option
              v-for="item in warningOptions"
              :key="item.value"
              :label="item.key"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchHandle" :loading='loading'>
            搜索
          </el-button>
        </el-form-item>
        <br/>
      </el-form>
    </div>
    <div class="intro-y col-span-12 overflow-auto mt-5">
      <table class="table table-report -mt-2">
        <thead>
        <tr>
          <th class="whitespace-no-wrap">承租人或使用人</th>
          <th class="whitespace-no-wrap">法人</th>
          <th class="whitespace-no-wrap">所在行业</th>
          <th class="whitespace-no-wrap">资产编号</th>
          <th class="whitespace-no-wrap">管理单位名称</th>
          <th class="whitespace-no-wrap">资产出租地址明细</th>
          <th class="whitespace-no-wrap">出现预警</th>
          <th class="whitespace-no-wrap">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in dataArr"
            :key="index"
            class="intro-x"
        >
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.lesseeName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.legalPersonName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.tradeName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.assetNumber
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.manageEnterpriseName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.certificateAddress
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.warningFlag ? '是' :'否'
              }}</div>
          </td>
          <td class="table-report__action whitespace-no-wrap">

              <a class="flex items-center mr-3 text-theme-1" href="javascript:;" @click='checkHandle(item)'>
                查看
              </a>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
    >
      <el-pagination
          layout="prev, pager, next"
          :background='false'
          :page-size="form.perPage"
          :current-page="form.page"
          @current-change="handleTableChange"
          :total="total">
      </el-pagination>
      <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='form.perPage'>
        <option :value='10'>10</option>
        <option :value='25'>25</option>
        <option :value='35'>35</option>
        <option :value='50'>50</option>
      </select>
    </div>
  </div>
</template>

<script>
  import {lesseeGetList,lesseeGetBusinessStat} from '../../api/tenant.js'
  import {getCompanyList} from '../../api/contract.js'
  import pie from './components/echarts/pie'
  import earlyList from './components/earlyList'
  export default {
    name: "tenantList",
    components: {
      pie,
      earlyList
    },
    data() {
      return {
        detail:[],
        form:{
          lesseeName:'',
          companyId:-1,
          tradeId:'全部',
          warningFlag:'',
          perPage:10,
          page:1
        },
        unitOptions:[],
        warningOptions:[
          {value:'',key:'全部'},
          {value:'1',key:'出现预警'},
          {value:'0',key:'未出现预警'},
        ],
        loading:false,
        dataArr:[],
        total: 0,
      }
    },
    methods: {
      legendselectchanged(params){
        this.form.tradeId = params.name
        this.lesseeGetList();
      },
      onShowSizeChange(e){
        this.form.page = 1;
        this.lesseeGetList();
      },
      handleTableChange(page){
        this.form.page=page;
        this.lesseeGetList();
      },
      getCompanyList(){
        getCompanyList().then(res => {
          let data = res.data
          if (data.code === '000') {
            this.unitOptions = data.content.list
          } else {
            this.unitOptions = []
          }
        }).catch(err => {
          console.log(err);
        })
      },
      sourceChange(val){},
      checkHandle(params){
        let status = 1
        if(params.lesseeType == 'PERSONAL'){
          status = 0
        }else if(params.lesseeType == 'ENTERPRISE'){
          status = 1
        }
        let url=this.$router.resolve({path:'/tenantManagement/tenantDetail',query:{broadside:params.lesseeName,status:status,contractId:params.contractId}}).href
        window.open(url)
      },
      searchHandle(){
        this.form.page = 1
        this.lesseeGetList();
      },
      lesseeGetList(){
        let para=Object.assign({},this.form)
        if(para.tradeId == '全部'){
          para.tradeId = ''
        }
        this.loading = true
        lesseeGetList(para).then(res => {
          this.loading = false
          let data = res.data
          if (data.code === '000') {
            let arr = data.content.list
            for (let i in arr){
              arr[i].key = Number(i)
            }
            this.dataArr = arr
            this.total = data.content.total
          } else {
            this.dataArr = []
            this.total = 0
          }
        }).catch(err => {
          this.loading = false
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
      lesseeGetBusinessStat(){
        lesseeGetBusinessStat().then(res => {
          let data = res.data
          if (data.code === '000') {
            this.detail = data.content
            this.detail.unshift({
              num : '',
              name : '全部',
            })
          } else {
            this.detail = []
          }
        }).catch(err => {
          console.log(err);
        })
      }
    },
    created() {
      this.getCompanyList()
      this.lesseeGetList()
      this.lesseeGetBusinessStat()
    },
  }
</script>

<style scoped lang="scss">
  .tenantList {
    min-height: calc(100vh - 84px);
    .row {
      background: #fff;
      border: 1px solid #f0f2f5;
      display: flex;
      height: 400px;
      justify-content: space-between;
    }
    .search-form{
      margin:15px 0;
    }
    .page{
      margin-top:15px;
      text-align: right;
    }
  }
</style>
